import moment from 'moment';
import { InputGroup } from 'react-bootstrap';
import { Form } from 'react-router-dom';

export function cleanJson(data) {
    return JSON.parse(JSON.stringify(data).replace(/{}/g, '""'));
}

export function formatTel(tel) {
    if (tel && tel.length === 10) {
        return tel.substring(0, 2) + ' ' + tel.substring(2, 4) + ' ' + tel.substring(4, 6) + ' ' + tel.substring(6, 8) + ' ' + tel.substring(8, 10);
    } else {
        return tel;
    }
}

export function formateDate(donnee) {
    if(donnee === null || donnee === undefined || donnee === '') return '';
    else return moment(donnee).format('DD/MM/YYYY');
    // console.log(donnee,  isNaN(donnee), moment(donnee).format('DD/MM/YYYY'), moment(parseInt(donnee.slice(6, -2), 10)).format('DD/MM/YYYY'));
    // return Object.keys(donnee).length === 0 ? '' : isNaN(donnee)?moment(donnee).format('DD/MM/YYYY'):moment(parseInt(donnee.slice(6, -2), 10)).format('DD/MM/YYYY');
}
export function formateDateUS(donnee) {
    if(donnee === null || donnee === undefined || donnee === '') return '';
    else return moment(donnee).format('YYYY-MM-DD');
    // console.log(donnee,Object.keys(donnee).length);
    // console.log(donnee,  isNaN(donnee), moment(donnee).format('YYYY-MM-DD'), moment(parseInt(donnee.slice(6, -2), 10)).format('YYYY-MM-DD'));
    // return Object.keys(donnee).length === 0 ? '' : isNaN(donnee)?moment(donnee).format('YYYY-MM-DD'):moment(parseInt(donnee.slice(6, -2), 10)).format('YYYY-MM-DD');
}
export function formateDateUSFromFr(donnee) {
    if(donnee === null || donnee === undefined || donnee === '') return '';
    else return moment(donnee, 'DD/MM/YYYY').format('YYYY-MM-DD');
    // console.log(donnee,Object.keys(donnee).length);
    // console.log(donnee,  isNaN(donnee), moment(donnee).format('YYYY-MM-DD'), moment(parseInt(donnee.slice(6, -2), 10)).format('YYYY-MM-DD'));
    // return Object.keys(donnee).length === 0 ? '' : isNaN(donnee)?moment(donnee).format('YYYY-MM-DD'):moment(parseInt(donnee.slice(6, -2), 10)).format('YYYY-MM-DD');
}

export function quoteToDoubleQuote(data) {
    let element = JSON.parse(JSON.stringify(data));
    Object.keys(element).forEach(key => {
        element[key] = ('' + element[key]).replace(/'/g, "''");
    });
    return element;

}

export function getColumnsName(data) {
    let fields = [];
    data.forEach(element => {
        Object.keys(element).forEach(key => {
            let name = namesAndIds.find(col => col.id === key);
            if (name) {
                key = name.name;
            }
            if (!fields.includes(key)) {
                fields.push(key);
            }
        });
    });
    return fields.sort();
}
export function getColumnsByNames(names) {
    let cols = [];
    names.forEach(name => {
        let col = columns.find(col => col.name === name);
        if (col) {
            cols.push(col);
        } else {
            let col = namesAndIds.find(col => col.name === name || col.id === name);
            if (col)
                cols.push({ name: col.name, selector: row => row[col.id], sortable: true, wrap: true });
            else
                cols.push({ name: name, selector: row => row[name], sortable: true, wrap: true });
        }
    });
    return cols;
}


export function getSelect(libelle, field, options, data, setData) {

    const handleInputChange = (field, value, data, setData) => {
        let newData = { ...data };
        newData[field] = value;
        setData(newData);
    }
    
    // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
    return <InputGroup className="mb-3" key={field}>
        <InputGroup.Text>{libelle}</InputGroup.Text>
        <Form.Select
            value={data[field]}
            onChange={(e) => handleInputChange(field, e.target.value, data, setData)}
        >
            {options.map((item, index) => (
                <option key={index} value={item}>{item}</option>
            ))}
        </Form.Select>
    </InputGroup>
}



const namesAndIds = [
    { name: 'Siret', id: 'siret' }, { name: 'Numéro TVA Intracommunautaire', id: 'numero_tva_intracommunautaire' }, { name: 'Code APE ou NAF', id: 'code_ape_ou_naf' },
    { name: 'Forme Juridique de la Société', id: 'forme_juridique_de_la_societe' }, { name: 'Montant du Capital', id: 'montant_du_capital' },
    { name: 'Entreprise', id: 'nom_de_l_entreprise' }, { name: 'Code postal', id: 'code_postal' }, { name: 'Réseau', id: 'reseau' },
    { name: 'Ville', id: 'ville' }, { name: 'E-mail', id: 'e_mail_1' }, { name: 'Réseau', id: 'reseau' }, { name: 'Feuille', id: 'reference' },
    { name: 'Prénom', id: 'prenom_adherent' }, { name: 'Adresse 2', id: 'adresse2' }, { name: 'E-mail 2', id: 'e_mail_2' },
    { name: 'E-mail 3', id: 'e_mail_3' }, { name: 'Département', id: 'numero_de_dpt' }, { name: 'Code métier', id: 'code_metier' },
    { name: 'Numéro client', id: 'numero_client' }, { name: 'Région', id: 'region' }, { name: 'Civilité', id: 'civilite' },
    { name: 'ID1', id: 'id1' }, { name: 'Adhérent ID', id: 'adherent_id' }, { name: 'Cotisation ID', id: 'cotisation_id' },
    { name: 'Choix de cotisation ID', id: 'choix_id' }, { name: 'Code', id: 'code' }, { name: 'Mail', id: 'mail' },
    { name: 'Date appel', id: 'date_appel' }, { name: 'Actif', id: 'is_actif' }, { name: 'Est entré dans le formulaire', id: 'has_connected' },
    { name: 'A rempli ses informations', id: 'has_filled' }, { name: 'A sélectionné un paiement', id: 'has_selected_paiement' }, { name: 'Fusionné', id: 'has_merged' },
];

export const etats = [
    { title: 'Tout', etat: '' },
    { title: 'Sans feuille de cotisation', etat: 'nocotisationid' },
    { title: 'A envoyer', etat: 'tobesend' },
    { title: 'Mail envoyé', etat: 'sent' },
    { title: 'Données complétées', etat: 'filled' },
    { title: 'Paiement sélectionné', etat: 'paiementselected' },
    { title: 'Validé', etat: 'valide' },
    { title: 'Finalisé', etat: 'paid' }];


const columns = [
    { name: 'Siret', width: '140px', selector: row => row['siret'], sortable: true, wrap: true },
    {
        name: 'Nom', selector: row => row.nom_adherent, cell: row => (<>
            {row.civilite} {row.nom_adherent} {row.prenom_adherent} <br />
        </>), sortable: true, wrap: true
    },
    {
        name: 'Adresse', selector: row => (
            <div>
                {row.adresse1} <br />
                {row.code_postal} {row.ville}
            </div>
        ), sortable: true, wrap: true
    },
    { name: 'Téléphone 1', width: '120px', selector: row => row.telephone, cell: row => formatTel(row.telephone), sortable: true, wrap: true, id: 'telephone' },
    { name: 'Téléphone 2', selector: row => row.numero_de_portable, cell: row => formatTel(row.numero_de_portable), sortable: true, wrap: true, id: 'numero_de_portable' },
];

